import React from 'react';
import { addonsNotice, products } from '../data/company';
import { Card, CardFoot, CardTag } from './Card';
import { Notice } from './Notice';
import { RichList } from './RichList';
import { Section } from './Section';
export function ProductsSection() {
  return <Section id="productos" number="04" title="Producto — descripción y precio" subtitle="Es el mismo kit en dos idiomas, cada uno en su propia tienda online, ambas operadas por Massive Faith LLC. El importe final siempre se muestra al cliente antes de confirmar el pago." data-id="element-82" data-mp="2empnx6lg5yhx">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-83" data-mp="1vppmoquxdnvt">
        {products.map(p => <Card key={p.title} highlighted data-id="element-84" data-mp="20oss4cethw4b">
            <CardTag data-id="element-85" data-mp="20pu20dk3kckg">{p.tag}</CardTag>
            <h3 className="mb-2 text-[19px] font-bold leading-snug tracking-[-0.01em] text-fg" data-id="element-86" data-mp="20qvhcu85bl7z">{p.title}</h3>
            <p className="mb-3.5 text-[14.5px] leading-relaxed text-muted" data-id="element-87" data-mp="3q1waqq8x3z5j">{p.description}</p>
            <RichList items={p.books} className="text-[14.5px]" data-id="element-88" data-mp="3v0pkq8ozx80y" />
            <p className="mb-0.5 mt-auto pt-2.5 text-[29px] font-extrabold tracking-[-0.02em] text-fg" data-id="element-89" data-mp="3889j9n77h1bs">
              {p.price}
              <span className="ml-2 text-sm font-medium text-muted line-through" data-id="element-90" data-mp="338dg1q6c1dxa">
                <span className="sr-only" data-id="element-91" data-mp="3hykpjged3mlu">Antes: </span>
                {p.was}
              </span>
            </p>
            <div className="mt-4" data-id="element-92" data-mp="3d2dre9s7jfeg">
              <CardFoot data-id="element-93" data-mp="2pa6p6tzswe74">
                Pago único · Entrega inmediata por email · Garantía de 30 días
                <br data-id="element-94" data-mp="2kc5bkol59731" />
                <a href={p.storeHref} target="_blank" rel="noopener noreferrer" className="text-accent-soft hover:underline" data-id="element-95" data-mp="2kcx41qjg2op3">
                  {p.storeLabel}
                </a>
              </CardFoot>
            </div>
          </Card>)}
      </div>
      <Notice text={addonsNotice} data-id="element-96" data-mp="dkvzxsj3gtnq" />
    </Section>;
}